import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=de3e5ed8&scoped=true"
import script from "./faq.vue?vue&type=script&lang=js"
export * from "./faq.vue?vue&type=script&lang=js"
import style0 from "./faq.vue?vue&type=style&index=0&id=de3e5ed8&prod&lang=css"
import style1 from "./faq.vue?vue&type=style&index=1&id=de3e5ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3e5ed8",
  null
  
)

export default component.exports